export default "__VITE_ASSET__eEWhARkS__"